<template>
    <div class="main_tab_grpbox mt-10 pc-visible">
        <!-- <h4 style="width: 100%;">{{ dispTitleList[slideIdx] }}</h4> -->
        <h4 style="width: 100%;">{{ chartList[slideIdx].tit }}</h4>
        <div class="swiper-container"  :style="setStyle()">
            <div class="swiper-wrapper">
                <div v-for="(chart, index) in chartList" class="swiper-slide main-realtime">
                    <Chart :key="chart.id" :chartid="chart.id" v-if="index === slideIdx" />
                </div>
            </div>
            <div class="btn_pre swiper-button-prev"></div>
            <div class="btn_nxt swiper-button-next"></div>
        </div>
    </div>
</template>

<script>
import Swiper from '@/assets/js/swiperjs/swiper-bundle.js';
import gripUtil from "@/libs/grip.util";
import { $_TYPE, $_WC } from '@/confs/common.const';
import Chart from '@/libs/grip.chart.v2.vue';
import { mapGetters } from "vuex";
export default {
    components: {
        Chart,
    },
    data() {
        return {
            swiper: undefined,
            slideIdx: 0,
            //
            interval: 30,
            category: 'Safety',
        }
    },
    watch: {
        chartList: {
            immediate: false,
            handler(newVal, oldVal) {
                this.$nextTick(()=> {
                    this.setSwiper();
                });
            }
        },
    },
    computed: {
        ...mapGetters({
            topMenuList: 'getTopMenuList',
        }),
        
        // dispChartIds() {
        //     let dispChartList =[];
        //     dispChartList = this.chartIds
        //     return dispChartList;
        // },
        chartList() {
            let list = [];
            if(Object.keys(this.topMenuList).length > 0) {
                let topMenuMap = gripUtil.toDict(this.topMenuList, 'code');
                let cList = topMenuMap[this.category].chartIds;
                let tList = topMenuMap[this.category].chartTitles;
                cList.forEach((d, idx) => {
                    let map = {id: d, tit: tList[idx]};                    
                    list.push(map);
                });
            }
            return list;
        },
    },
    mounted() {
        if(typeof this.swiper === $_TYPE.UNDEF) {
            this.setSwiper();
        }
    },
    methods: {
        setSwiper(){
            const _this = this;
            if(typeof this.swiper !== $_TYPE.UNDEF) {
                this.swiper.slideTo(0);
            }
            this.swiper = new Swiper('.swiper-container', {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView : 1,
                // effect : 'coverflow',
                pagination: {
                    el: '.swiper-pagination'
                },
                /*
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                */
                mousewheel: true,
                keyboard: true,
                loop: false,
                spaceBetween: 30,
                autoplay: {
                    delay: 1000 * _this.interval,
                },
                on: {
                    init() {
                    },
                    slideChange(e){
                        _this.slideIdx = this.realIndex;
                        _this.$eventBus.$emit("Swiper::slide-change");
                    },
                    touchMove(){
                        _this.$eventBus.$emit("Swiper::touch-move");
                    },
                },
            });
        },
        setStyle() {
            if($_WC.viewScale > 1) {
                return 'height: 600px;'
            }
            if($_WC.viewScale == 1) {
                return 'height: 250px;'
            }
        },
    },
};
</script>
<style>
.swiper-slide.main-realtime {
    padding: 0 0 0 0;
}
</style>
